export const FILTER_TYPES = {
  SERVER: "server",
  CLIENT: "client"
};
